// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fakeGrid td,.fakeGrid th{height:30px;padding-top:0;padding-bottom:0}.fakeGrid th{height:35px;line-height:35px;white-space:nowrap;color:#666;font-size:.87em;font-weight:400}", ""]);
// Exports
module.exports = exports;
